import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

export const GenericBackendResponse = types.model('GenericBackendResponse', {
    code: 0,
});

export type TypeGenericBackendResponse = Instance<typeof GenericBackendResponse>;
export default GenericBackendResponse;
